import { Education } from '../../../../types/education'
import { formatDate } from '../../../../utils/numbersFormatting'

interface EducationItemProps {
  education: Education
}

export default function EducationItem({ education }: EducationItemProps) {
  return (
    <div className="flex gap-4 pb-8 border-b border-white-200 last:border-0">
      <img
        src={`https://logo.clearbit.com/${education?.school?.toLowerCase().replace(/\s+/g, '')}.edu`}
        alt={education.school}
        className="w-12 h-12 rounded object-contain bg-white-50"
        onError={e => {
          const target = e.target as HTMLImageElement
          target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(education.school)}&background=random`
        }}
      />

      <div className="flex-1">
        <h3 className="text-lg font-semibold text-white-900">
          {education.school}
        </h3>
        <p className="text-base text-white-700">{education.degree}</p>
        <p className="text-sm text-white-500 mb-4">
          {formatDate(education.startDate * 1000)}
          {' '}
          -
          {' '}
          {formatDate(education.endDate * 1000)}
        </p>

        {education.courses && (
          <div className="mb-3">
            <p className="text-sm">
              <span className="font-semibold text-white-700">Courses:</span>
              {' '}
              <span className="text-white-600">
                {education.courses.join(', ')}
              </span>
            </p>
          </div>
        )}

        {education.extracurricularActivities && (
          <div className="mb-3">
            <p className="text-sm">
              <span className="font-semibold text-white-700">Activities:</span>
              {' '}
              <span className="text-white-600">
                {education.extracurricularActivities.join(', ')}
              </span>
            </p>
          </div>
        )}

        {education.honors && (
          <div>
            <p className="text-sm">
              <span className="font-semibold text-white-700">Honors:</span>
              {' '}
              <span className="text-white-600">
                {education.honors.join(', ')}
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
